import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';
import profileStatus from '../../../constants/profile-status';

import { showNotificationLayer } from '../../../actions/notification';
import { queryCommon } from '../../../api/queries';
import { getProfile } from '../../../api/client';
import { getCommunicationTemplate } from '../../../api/communication';
import { create as c } from '../../../api/common';

const loadingPost = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const getTemplates = params => {
  return dispatch => {
    queryCommon({ ac: 'templateList', params })
      .then(response =>
        dispatch({
          type: TYPES.templateList,
          payload: response.data.map(({ id, name, clientId }) => ({
            id,
            name,
            clientId,
          })),
        })
      )
  }
};

export const getTemplateDetails = params => {
  return dispatch => {
    getCommunicationTemplate(params.id)
      .then(response =>
        dispatch({
          type: TYPES.templateDetails,
          payload: response.data,
        })
      )
      .catch(() => {
        dispatch({
          type: TYPES.templateDetails,
          payload: {},
        })
      })
  }
};

export const create = params => {
  return dispatch => {
    dispatch(loadingPost());

    c(params.formParams, 'automatic.communication.php')
      .then(response => {
        dispatch(loadingPost());
        dispatch(hideFormManagerLayer());

        dispatch({
          type: TYPES.insertItemList,
          payload: response.data,
        });

        dispatch(showNotificationLayer('Solicitação enviada!'));
      })
      .catch(responseFail => {
        dispatch(loadingPost());
        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data,
        });
      })
  }
};

export const showFormManagerLayer = () => {
  return async dispatch => {
    try {
      dispatch({
        type: COMMON_TYPES.toggleLayer, payload: 'manager'
      });

      const profile = await getProfile();

      return dispatch({
        type: COMMON_TYPES.detailsGetResult,
        payload: {
          data: {
            profile: profile.data.data.find(
              a => a.status === profileStatus.accept && a.enabled
            ) || null,
          }
        },
      });
    }
    catch (error) {
      return dispatch({ type: COMMON_TYPES.detailsGetResultError });
    }
  }


};

export const hideFormManagerLayer = () => [
  { type: COMMON_TYPES.toggleLayer, payload: null },
  { type: COMMON_TYPES.formClearValues },
];
